import React, { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import FilterAccommodationType from 'client/components/FilterAccommodationTypes'
import FilterCategory from 'client/components/FilterCategory'
import FilterFacilities from 'client/components/FilterFacilities'
import FilterPrices from 'client/components/FilterPrices'
import FilterRatings from 'client/components/FilterRatings'
import { type FormValues } from '@s4l/ds'
import { FiltersContext } from '../FiltersContainer/context'
import FilterThemes from 'client/components/FilterThemes'
import { SearchFilters } from '@s4l/uikit'
import { SearchFilters as SearchFiltersModel } from '@s4l/stayforlong/property/SearchFilters'
import { useSelector } from 'react-redux'
import { getDistributionPriceRange, getIsFetching } from 'src/effects/Properties/selectors'
import { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'

interface IFiltersProps {
  onSubmit?: (filters: FormValues) => void
}

const Filters = ({ onSubmit }: IFiltersProps) => {
  const { query } = useRouter()
  const distributionPriceRange = useSelector(getDistributionPriceRange)
  const isFetching = useSelector(getIsFetching)

  const hasNewFilters = query.ff?.includes('new_filters')
  const hasExtendedFilters = query.ff?.includes('extended_filters')

  const { filters, setFilters } = useContext(FiltersContext)
  const [isLoadingPriceDistribution, setIsLoadingPriceDistribution] = useState(true)

  function handleApplyFilters(newFilters: FormValues) {
    setFilters(prev => ({ ...prev, ...newFilters }))
  }

  function onSubmitInternal(newFilters: FormValues) {
    handleApplyFilters(newFilters)
    onSubmit?.(newFilters)
  }

  const filtersModel = SearchFiltersModel.fromLegacyContext(filters)

  const listOfPriceDistributionModel =
    ListOfPriceDistribution.fromLegacyContext(distributionPriceRange)

  useEffect(() => {
    if (!isLoadingPriceDistribution) return

    setIsLoadingPriceDistribution(isFetching)
  }, [isFetching, isLoadingPriceDistribution])

  if (hasNewFilters) {
    return (
      <SearchFilters
        isLoadingPriceDistribution={isLoadingPriceDistribution}
        onFilterChange={handleApplyFilters}
        onSubmit={onSubmitInternal}
        defaultFiltersJSON={filtersModel.toJSON()}
        listOfPriceDistributionJSON={listOfPriceDistributionModel.toJSON()}
        showExtendedFilters={hasExtendedFilters}
      />
    )
  }

  return (
    <>
      <FilterPrices />
      <FilterCategory />
      <FilterRatings />
      <FilterThemes />
      <FilterAccommodationType />
      <FilterFacilities />
    </>
  )
}

export default Filters
